<template>
  <div :class="$style.title">
    <div :class="$style.header" v-line-clamp:1="1">
      <p
        v-line-clamp:1="1"
        class="semibold"
        v-if="fullConversationNameWithIds.length"
      >
        Chat with:
      </p>
      <p class="paragraph-large capitalize" data-ref="name">
        <span v-if="currentConversation && currentConversation.object_name">{{
          currentConversation.object_name
        }}</span>
        <router-link
          v-else
          v-for="(participant, index) in fullConversationNameWithIds"
          :key="index"
          :to="{
            name: 'user-profile',
            params: { userId: participant.id }
          }"
        >
          <DoNotTrack
            ><span :class="$style.comma">{{
              participant.name
            }}</span></DoNotTrack
          >
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getConversationNameWithIds } from '@/helpers/conversations';

export default {
  computed: {
    ...mapGetters(['currentUserId']),
    ...mapGetters('chats', ['currentConversation']),
    fullConversationNameWithIds() {
      return getConversationNameWithIds(
        this.currentConversation,
        this.currentUserId
      );
    }
  }
};
</script>

<style lang="scss" module>
@import './ConversationHeader.scss';
</style>
